import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useUsers from '../../context/UsersContext';
import usePages from '../../context/PageContext';
import { IconButton, useMediaQuery } from '@mui/material';
import { getIcon } from '../../utils/helper';

export const Widget4Page = () => {
  const { getUser, user } = useUsers();
  const { setPages } = usePages();
  const navigate = useNavigate();
  const isLgUp = useMediaQuery('(min-width:960px)');

  useEffect(() => {
    if (!Object.keys(user).length) getUser();
  }, []);

  const handleNavigate = (data) => {
    navigate(`/app/${data.subMenuUrl}`);
    setPages({ subMenuName: data.name });
  };

  return (
    <div className="bg-[#e9f3fc] px-6 pt-5" style={{ minHeight: 'calc(100vh - 65px)' }}>
      <div className="flex flex-wrap gap-5 justify-center">
        {user?.favouriteMenu
          ?.filter((favouriteMenu) =>
            isLgUp ? favouriteMenu.showOnHomePage : favouriteMenu.showOnHomePage && favouriteMenu.showOnPhone
          )
          ?.sort((a, b) => (isLgUp ? a.visOrder - b.visOrder : a.phoneVisOrder - b.phoneVisOrder))
          ?.map((favouriteMenu) => (
            <div
              key={favouriteMenu.id}
              className="border-4 border-[#16a34a] h-[200px] w-[350px] bg-[#d8f4f8] text-[#16a34a] font-bold cursor-pointer flex flex-col items-center justify-center px-2 text-center hover:bg-[#bbf7d0] transition  duration-300 ease-in-out hover:-translate-y-1 hover:scale-110 rounded-2xl"
              onClick={() => handleNavigate(favouriteMenu)}
            >
              <div className="text-2xl mb-2">{favouriteMenu.name}</div>
              <IconButton sx={{ margin: 0, padding: 0 }}>{getIcon(favouriteMenu.icon, '3rem', '#16a34a')}</IconButton>
            </div>
          ))}
      </div>
    </div>
  );
};
